import React, { useEffect, useState } from 'react'
import { FaList } from 'react-icons/fa'
import { RxCross1 } from 'react-icons/rx'
import { Link, useNavigate } from 'react-router-dom'
import { FaEye } from 'react-icons/fa'
import { IoIosNotificationsOutline, IoMdArrowDropdown } from 'react-icons/io'
import { useDispatch, useSelector } from 'react-redux'
import { backend_url_img } from '../api/server'
import { useTranslation } from 'react-i18next'
import i18next from 'i18next'
import cookies from 'js-cookie'
import { socket } from '../utils/utils'
import { getCurrentTime } from '../utils/timeConvertor'
import {
  get_user_info,
  add_notification,
  // get_order_notifications,
  update_auth_notification,
  messageClear,
  add_notification_poster,
  add_notification_stock,
  logout,
} from '../store/Reducers/authReducer'

const languages = [
  {
    code: 'kr',
    name: 'کوردی',
    dir: 'rtl',
    country_code: 'kr',
    image: `${backend_url_img}/uploads/language/ku.png`,
    // '../../../images/kur.png',
  },
  {
    code: 'ar',
    name: 'عربي',
    dir: 'rtl',
    country_code: 'ar',
    image: `${backend_url_img}/uploads/language/ar.png`,
  },
  // {
  //   code: 'en',
  //   name: 'English',
  //   dir: 'ltr',
  //   country_code: 'en',
  //   image: `${backend_url_img}/uploads/language/en.png`,
  // },
]

const Header = ({ showSidebar, setShowSidebar }) => {
  // const currentLanguageCode = cookies.get('i18next') || 'en'
  const currentLanguageCode = cookies.get('i18next') || 'kr'
  const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { userInfo, successMessage, errorMessage, role } = useSelector(
    (state) => state.auth
  )

  const [custNote, setCustNote] = useState(false)
  const [unseenCount, setUnseenCount] = useState(0)

  useEffect(() => {
    socket.on('connect', () => {
      console.log('Connected to socket server:', socket.id)
    })

    socket.on('stockUpdate', (data) => {
      if (userInfo?.role) {
        dispatch(get_user_info())
      }

      if (userInfo?.notifications) {
        const unseenNotifications = userInfo.notifications.filter(
          (notification) => notification.notification_status === 'unseen'
        ).length
        setUnseenCount(unseenNotifications || 0)
      }
    })
    socket.on('disconnect', () => {
      console.log('Disconnected from socket server.')
    })
  }, [])

  useEffect(() => {
    if (userInfo?.notifications) {
      const unseenNotifications = userInfo.notifications.filter(
        (notification) => notification.notification_status === 'unseen'
      ).length
      setUnseenCount(unseenNotifications || 0)
    }
  }, [userInfo, successMessage])

  useEffect(() => {
    const currentDate = getCurrentTime()

    const handleStockUpdate = (data) => {
      dispatch(
        add_notification({
          authId: userInfo._id,
          orderId: data.orderId,
          delivery_status: data.status,
          order_status: data.status,
          enNote: `New Order`,
          kuNote: `داواکاری نوێ`,
          arNote: `طلب الجدید`,
          createdAt: currentDate,
        })
      )
    }

    const handleOrderStatusUpdate = (data) => {
      if (userInfo.role === 'poster') {
        if (data.status === 'on way') {
          dispatch(
            add_notification_poster({
              authId: userInfo._id,
              orderId: data.orderId,
              delivery_status: data.status,
              enNote: `Order Status Update`,
              kuNote: `داواکاری نوێکرایەوە`,
              arNote: `تم تجديد الطلب`,
              createdAt: currentDate,
            })
          )
        }
      }
      if (userInfo.role === 'stockAdmin') {
        if (data.status === 'newOrder') {
          dispatch(
            add_notification_stock({
              authId: userInfo._id,
              orderId: data.orderId,
              delivery_status: data.status,
              enNote: `Order Status Update`,
              kuNote: `داواکاری نوێکرایەوە`,
              arNote: `تم تجديد الطلب`,
              createdAt: currentDate,
            })
          )
        }
      }

      dispatch(
        add_notification({
          authId: userInfo._id,
          orderId: data.orderId,
          delivery_status: data.status,
          enNote: `Order Status Update`,
          kuNote: `داواکاری نوێکرایەوە`,
          arNote: `تم تجديد الطلب`,
          createdAt: currentDate,
        })
      )

      // dispatch(get_order_notifications(userInfo.role))
    }

    socket.on('connect', () => {
      console.log('Connected to socket server:', socket.id)
    })

    socket.on('stockUpdate', handleStockUpdate)
    socket.on('orderStatusUpdate', handleOrderStatusUpdate)

    socket.on('disconnect', () => {
      console.log('Disconnected from socket server.')
    })

    // Cleanup listeners to prevent duplicates
    return () => {
      socket.off('stockUpdate', handleStockUpdate)
      socket.off('orderStatusUpdate', handleOrderStatusUpdate)
      socket.off('connect')
      socket.off('disconnect')
    }
  }, [dispatch, userInfo._id])

  useEffect(() => {
    const handleStockChangePassword = (data) => {
      if (userInfo._id === data.userId) {
        dispatch(logout({ navigate, role }))
      }
    }
    socket.on('adminPasswordChange', handleStockChangePassword)

    return () => {
      socket.off('adminPasswordChange', handleStockChangePassword)
      socket.off('connect')
      socket.off('disconnect')
    }
  }, [userInfo])

  useEffect(() => {
    if (userInfo?.role) {
      dispatch(get_user_info())
    }
  }, [])

  const handleUpdateNotification = (noteId) => {
    dispatch(
      update_auth_notification({ notificationId: noteId, authId: userInfo._id })
    )
  }

  useEffect(() => {
    if (successMessage) {
      dispatch(get_user_info())
      dispatch(messageClear())
    }

    if (errorMessage) {
      dispatch(messageClear())
    }
  }, [successMessage, errorMessage])

  useEffect(() => {
    document.body.dir = currentLanguage.dir || 'ltr'
    document.title = t('home.app_title')
  }, [currentLanguage, t])

  const getNotification = (note) => {
    switch (currentLanguage.code) {
      case 'ar':
        return note?.arNote
      case 'kr':
        return note?.kuNote
      default:
        return note?.enNote
    }
  }

  // const headerLogo = '../../../images/logo.png';
  // const langlogo = '../../../images/language.png';

  return (
    <div className="fixed top-0 left-0 w-full shadow-md z-[999]">
      <div
        className={` ${
          currentLanguage.dir === 'ltr'
            ? 'ml-0 lg:ml-[260px]'
            : 'mr-0 lg:mr-[260px]'
        } ${
          currentLanguage.dir
        } h-[65px] flex justify-between items-center bg-[#ffffff] px-6 transition-all`}
      >
        <div
          onClick={() => setShowSidebar(!showSidebar)}
          className="w-[35px] flex lg:hidden h-[35px] rounded-sm bg-primary shadow-lg hover:shadow-indigo-500/50 justify-center items-center cursor-pointer text-white"
        >
          <span>
            <FaList />
          </span>
        </div>

        <div className="hidden md:block">
          {/* <input className='px-3 py-2 outline-none border bg-transparent border-slate-700 rounded-md text-[#423d72] focus:border-indigo-300 overflow-hidden' type="text" name='search' placeholder='search' /> */}
        </div>

        <div className="flex justify-center items-center gap-8 relative">
          <div className="flex justify-center items-center">
            <div className="flex justify-center items-center gap-6">
              <div className="flex justify-center items-center relative top-2">
                {/* {userInfo?.role === 'admin' ? ( */}
                <div
                  onClick={() => setCustNote(true)}
                  className="w-[20px] h-[40px] relative cursor-pointer"
                >
                  {/* Notification Icon */}
                  <div className="relative flex justify-center items-center">
                    <IoIosNotificationsOutline size={30} />
                  </div>
                  {/* Notification Badge */}
                  <div className="absolute flex justify-center items-center bg-red-500 text-white rounded-full w-[28px] h-[28px] top-0 ltr:right-5 rtl:right-0 translate-x-[50%] -translate-y-[50%]">
                    {unseenCount}
                  </div>
                </div>
                {/* ) : (
                  <div
                    onClick={() => setCustNote(true)}
                    className="w-[30px] h-[40px] relative cursor-pointer"
                  >
                 
                    <div className="relative flex justify-center items-center">
                      <IoIosNotificationsOutline size={30} />
                    </div>
                  
                    <div className="absolute flex justify-center items-center bg-red-500 text-white rounded-full w-[28px] h-[28px] top-0 right-0 translate-x-[50%] -translate-y-[50%]">
                      {totalNotification}
                    </div>
                  </div>
                )} */}
              </div>

              <div className="flex group cursor-pointer text-slate-800  text-sm justify-center items-center gap-2 relative after:h-[18px] after:w-[1px] after:bg-[#afafaf] after:-right-[16px] after:absolute before:absolute before:h-[18px] before:bg-[#afafaf] before:w-[1px] before:-left-[20px]">
                <img
                  src={currentLanguage.image}
                  className="w-7"
                  alt={currentLanguage.name}
                />
                {/* <MdOutlineLanguage /> */}
                <span>
                  <IoMdArrowDropdown />
                </span>
                <ul className="absolute invisible transition-all top-8 rounded-sm duration-200 text-black p-2 w-[100px] flex flex-col gap-3 group-hover:visible group-hover:top-6  group-hover:bg-[#F9FBFE] z-[99999]">
                  {languages?.map(({ code, name, country_code, image }) => (
                    <li key={country_code}>
                      <a
                        href="/"
                        className="dropdown-item"
                        onClick={(e) => {
                          e.preventDefault()
                          i18next.changeLanguage(code)
                        }}
                        disabled={code === currentLanguageCode}
                      >
                        <div className="flex justify-between items-center">
                          <span
                            className={
                              code === currentLanguageCode
                                ? 'text-[#2A629A] font-bold'
                                : 'text-black'
                            }
                          >
                            {name}
                          </span>
                          <img
                            src={image}
                            className="w-[22px] h-[15px]"
                            alt={`${name} logo`}
                          />
                        </div>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="flex justify-center items-center flex-col text-end">
                <h2 className="text-md font-bold">{userInfo?.name}</h2>
                <span className="text-[#928d8d] text-[14px] w-full font-normal">
                  {userInfo?.role}
                </span>
              </div>

              {/* {userInfo?.role === 'admin' ? ( */}
              <img
                className="w-[45px] h-[45px] rounded-full overflow-hidden"
                src={`${backend_url_img}/${userInfo?.image}`}
                alt=""
              />
              {/* ) : (
                <img
                  className="w-[45px] h-[45px] rounded-full overflow-hidden"
                  src={`${backend_url_img}/uploads/${userInfo?.image}`}
                  alt=""
                />
              )} */}
            </div>
          </div>
        </div>
      </div>

      {/* {userInfo?.role === 'admin' ? (
        <> */}
      {custNote ? (
        <div className="fixed top-19 rtl:left-0 ltr:right-0 w-full bg-[#0000004b] h-screen z-[9999]">
          <div className="fixed pb-16  top-19 py-0 rtl:left-0 ltr:right-0 h-full w-[80%] lg:w-[25%]  bg-white flex flex-col overflow-y-scroll justify-between shadow-sm">
            {userInfo?.notifications &&
            userInfo?.notifications?.length === 0 ? (
              <div className="w-full h-screen flex items-center justify-center">
                <div className="flex w-full justify-end top-16 pt-4 px-0  fixed  ltr:right-3  rtl:left-8">
                  <RxCross1
                    size={25}
                    className="cursor-pointer"
                    onClick={() => setCustNote(false)}
                  />
                </div>
                <h5>{t('dashboardS.notification_empty')}</h5>
              </div>
            ) : (
              <>
                <div>
                  <div className="flex bg-primary w-full justify-end items-center p-2 pr-5 px-6">
                    <RxCross1
                      size={25}
                      className="cursor-pointer text-white"
                      onClick={() => setCustNote(false)}
                    />
                  </div>
                  {/* Item length */}
                  <div className="flex justify-center items-center  p-2">
                    {/* <IoBagHandleOutline size={25} /> */}
                    <h5 className="text-[20px] font-[500]">
                      {unseenCount} {t('noteS.order_notification')}
                    </h5>
                  </div>
                  {/* <div className="relative px-2 flex justify-end w-full"></div> */}

                  {/* cart Single Items */}
                  <br />
                  <div className="w-full border-t p-2">
                    {userInfo?.notifications &&
                      userInfo.notifications
                        .filter((data) => data.notification_status === 'unseen') // Filter notifications
                        .map((data, index) => (
                          <div
                            key={index}
                            className="flex flex-col border-b px-3 py-2"
                          >
                            <div
                              className="flex justify-end items-center"
                              onClick={() => {
                                setCustNote(false)
                                handleUpdateNotification(data._id)
                              }}
                            >
                              <Link to={`/${userInfo?.role}/orders`}>
                                <FaEye size={25} />
                              </Link>
                            </div>

                            <div className="w-full flex items-center">
                              <div className="pl-[5px]">
                                <h1>{data._id}</h1>
                                <h3>{getNotification(data)}</h3>
                                <h3>{data?.createdAt}</h3>
                              </div>
                            </div>
                          </div>
                        ))}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      ) : // <CustomerNotification
      //   setNoteId={setNoteId}
      //   setCustNote={setCustNote}
      //   unseenNotes={authNotifications}
      //   userInfo={userInfo}
      // />
      null}
      {/* </>
      ) : (
        <>
          {' '}
          {custNote ? (
            <CustomerNotification
              setCustNote={setCustNote}
              sellerUnseenNotes={myNotifications}
              userInfo={userInfo}
            />
          ) : null}
        </>
      )} */}
    </div>
  )
}

export default Header
